export const DEFAULT_LOBBY_WS_RETRY = {
  maxRetriesOnError: 12,
  maxReconnectsOnClose: 24,
  baseDelayMs: 100,
  maxDelayMs: 5000,
} as const;
